import React, { useState } from 'react';

const Faq = () => {
    const [openIndex, setOpenIndex] = useState(0);

    const faqItems = [
        {
            id: 1,
            question: "Lorem Ipsum is simply dummy texto print ing iandtype?",
            answer: "Lorem ipsum dolor sit amet consectetur. Scelerisque consectetur viverra semper tincidunt diam vitae aenean elit. Vitae vitae facilisis malesuada faucibus est est elit est. Placerat sollicitudin aliquet aenean faucibus nisl convallis pellentesque cursus vitae. Scelerisque diam nisi ultricies ipsum erat tortor vehicula sit. Duis tellus sed praesent tincidunt."
        },
        {
            id: 2,
            question: "Lorem Ipsum is simply dummy texto print ing iandtype?",
            answer: "Lorem ipsum dolor sit amet consectetur. Scelerisque consectetur viverra semper tincidunt diam vitae aenean elit. Vitae vitae facilisis malesuada faucibus est est elit est. Placerat sollicitudin aliquet aenean faucibus nisl convallis pellentesque cursus vitae. Scelerisque diam nisi ultricies ipsum erat tortor vehicula sit. Duis tellus sed praesent tincidunt."
        },
        {
            id: 3,
            question: "The standard chunk of Lorem Ipsum used since?",
            answer: "Lorem ipsum dolor sit amet consectetur. Scelerisque consectetur viverra semper tincidunt diam vitae aenean elit. Vitae vitae facilisis malesuada faucibus est est elit est. Placerat sollicitudin aliquet aenean faucibus nisl convallis pellentesque cursus vitae. Scelerisque diam nisi ultricies ipsum erat tortor vehicula sit. Duis tellus sed praesent tincidunt."
        },
        {
            id: 4,
            question: "Contrary to popular belief, Lorem Ipsum is not simply?",
            answer: "Lorem ipsum dolor sit amet consectetur. Scelerisque consectetur viverra semper tincidunt diam vitae aenean elit. Vitae vitae facilisis malesuada faucibus est est elit est. Placerat sollicitudin aliquet aenean faucibus nisl convallis pellentesque cursus vitae. Scelerisque diam nisi ultricies ipsum erat tortor vehicula sit. Duis tellus sed praesent tincidunt."
        },
        {
            id: 5,
            question: "Lorem Ipsum is simply dummy texto print ing iandtype?",
            answer: "Lorem ipsum dolor sit amet consectetur. Scelerisque consectetur viverra semper tincidunt diam vitae aenean elit. Vitae vitae facilisis malesuada faucibus est est elit est. Placerat sollicitudin aliquet aenean faucibus nisl convallis pellentesque cursus vitae. Scelerisque diam nisi ultricies ipsum erat tortor vehicula sit. Duis tellus sed praesent tincidunt."
        },
        {
            id: 6,
            question: "Lorem Ipsum is simply dummy texto print ing iandtype?",
            answer: "Lorem ipsum dolor sit amet consectetur. Scelerisque consectetur viverra semper tincidunt diam vitae aenean elit. Vitae vitae facilisis malesuada faucibus est est elit est. Placerat sollicitudin aliquet aenean faucibus nisl convallis pellentesque cursus vitae. Scelerisque diam nisi ultricies ipsum erat tortor vehicula sit. Duis tellus sed praesent tincidunt."
        }
    ];

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <section id="faqs" className="faqs-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="faqs-block">
                                <div className="accordion" id="accordionExample1">
                                    {faqItems.slice(0, 2).map((item, index) => (
                                        <div className="accordion-item" key={item.id}>
                                            <h4 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${openIndex === index ? '' : 'collapsed'}`}
                                                    type="button"
                                                    onClick={() => handleToggle(index)}
                                                    aria-expanded={openIndex === index}
                                                >
                                                    {item.question}
                                                </button>
                                            </h4>
                                            <div
                                                className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`}
                                            >
                                                <div className="accordion-body">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="faqs-block">
                                <div className="accordion" id="accordionExample2">
                                    {faqItems.slice(2,6).map((item, index) => (
                                        <div className="accordion-item" key={item.id}>
                                            <h2 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${openIndex === index + 3 ? '' : 'collapsed'}`}
                                                    type="button"
                                                    onClick={() => handleToggle(index + 3)}
                                                    aria-expanded={openIndex === index + 3}
                                                >
                                                    {item.question}
                                                </button>
                                            </h2>
                                            <div
                                                className={`accordion-collapse collapse ${openIndex === index + 3 ? 'show' : ''}`}
                                            >
                                                <div className="accordion-body">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Faq;